import React, { useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import { useOutsideClickForTwoRef } from '../../../../Hooks/useOutsideClickForTwoRef';
import DotsVertical from '../../../../Assets/OrderManagement/DotsVertical.svg';
import showhide from "../../../../Assets/ShowHide.svg";
import { Link, useLocation } from 'react-router-dom';
import KebabMenu from './KebabMenu';
import { closeCategoryKebabMenu, fetchCategories, openCategoryKebabMenu } from '../../../../Features/collectionsSlice';
import { CategoriesContext } from '../../../../Context/Collections/CategoryContext';
import { updateCategory } from '../../../../lib/utils/apiCalls';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';
import { showToast } from '../../../../Components/Toaster/Toaster';

function CategoryBar({ category, isSelected }) {
    const dispatch = useDispatch();
    const location = useLocation();

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    const { selectedCategories, setSelectedCategories } = useContext(CategoriesContext);

    const handleToggleClick = async () => {
        let visibilityValue;

        if(category.isVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            const response = await updateCategory(callData, category.id);
            if(response?.status === 200) {
                dispatch(fetchCategories());
            }
            else {
                showToast('Error updating category visibility.', 'error');
            }
        }
        catch(err) {
            showToast('Error updating category visibility.', 'error');
        }
    }

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeCategoryKebabMenu());
    });

    const kebabCategoryId = useSelector((state) => state.collections.categoryKebab.categoryId);

    const handleSelectBoxClick = () => {
        if(selectedCategories.includes(category.id)) {
            const filteredList = selectedCategories.filter(item => item !== category.id);
            setSelectedCategories(filteredList);
        }
        else {
            setSelectedCategories([ ...selectedCategories, category.id ]);
        }
    }

    const handleOpenKebab = () => {
        if(kebabCategoryId === category.id) {
            dispatch(closeCategoryKebabMenu());
        }
        else {
            dispatch(openCategoryKebabMenu(category.id));
        }
    }

    return (
        <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA] select-none">
            <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[6px]">
                <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                </div>

                <Link to={`${location.pathname}/categories/${category.id}`} className="w-[calc(100%-32px)] flex items-center gap-2">
                    {
                        category.categoryImgUrl.length > 0 ? 
                        <div className="size-16 flex items-center justify-center rounded-lg overflow-hidden">
                            <img className='size-full object-cover' src={getCachedMediaUrl(category.categoryImgUrl[0])} alt="" />
                        </div> : 
                        <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                    }

                    <h1 className='font-semibold text-[14px] leading-6 text-[#121212] w-[calc(100%-64px)] whitespace-nowrap overflow-hidden text-ellipsis'>{category.categoryName}</h1>
                </Link>
            </div>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{category.collectionCount}</h2>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{category.productCount}</h2>

            <div className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[26px]">
                <button onClick={handleToggleClick} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${category.isVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${category.isVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="w-[44px] flex items-center justify-center">
                {
                    selectedCategories?.length === 0 && 
                    <div onClick={handleOpenKebab} ref={kebabButtonRef} className='relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer'>
                        <img src={DotsVertical} alt="" />

                        {
                            kebabCategoryId === category.id && 
                            <KebabMenu 
                                boxRef={kebabRef} 
                                category={category} 
                            />
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default CategoryBar;
